import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  inline-size: 100%;
`;

export const FieldLabel = styled.p`
  margin: 0;

  color: #2c4692;
  font-weight: 700;
  font-size: 14px;
  font-family: ${fontRobotoCondensed};
  line-height: normal;
`;
